import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Input, Table, Typography, Space, Tooltip, Button, Badge, Row, Col, Tag, Spin, Popconfirm, Modal, DatePicker, Image } from 'antd';
import { EyeOutlined, SearchOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import axios from 'axios';
import moment from 'moment';
import Utils from '../../../misc/Utils';
import Enums from '../../../misc/Enums';
import DocumentViewer from '../../../components/document-viewer/DocumentViewer';
import ProcessingModal from '../../../components/processing/ProcessingModal';

const { Text, Link } = Typography;

export function ApplicationListMakati() {
   const navigate = useNavigate();
   const [searchText, setSearchText] = useState("");
   const [searchedColumn, setSearchedColumn] = useState("");

   const user_role = Utils.getCurrentUserInfo(Enums.UserInfo.role);

   const customFormat = value => `${value.format('MMM. D, YYYY h:mm a')}`;
   // const subdomain = localStorage.getItem("lms-subdomain");

   const [legendCount, setLegendCount] = useState({
      pending: 0,
      accepted: 0,
      not_accepted: 0,
      for_interview: 0,
      enrolled: 0,
      rejected: 0,
      medical: 0,
      payment: 0
   });

   const [applicantList, setApplicantList] = useState([]);
   const [applicantListFiltered, setApplicantListFiltered] = useState([]);
   const [listLoading, setListLoading] = useState(false);
   const [updating, setUpdating] = useState(false);
   const [schedule, setSchedule] = useState(null);
   const [applicantID, setApplicantID] = useState(null);
   // const [validPoP, setValidPoP] = useState(false);
   const [docToView, setDocToView] = useState(null);
   // const [bankDetails, setBankDetails] = useState(null);
   const [receiptNo, setReceiptNo] = useState(null);
   const [dpData, setDpData] = useState({
      document: "",
      receipt_no: "",
      status: ""
   });
   const [applicationStatus, setApplicationStatus] = useState(null);

   const [modalSchedule, setModalSchedule] = useState(false);
   const [modalPoPValidate, setModalPoPValidate] = useState(false);
   const [modalAFPoP, setModalAFPoP] = useState(false);
   const [modalMedCert, setModalMedCert] = useState(false);

   useEffect(() => {
      Utils.verifyJwt();

      window.addEventListener('error', e => {
         if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
            const resizeObserverErrDiv = document.getElementById(
               'webpack-dev-server-client-overlay-div'
            );
            const resizeObserverErr = document.getElementById(
               'webpack-dev-server-client-overlay'
            );
            if (resizeObserverErr) {
               resizeObserverErr.setAttribute('style', 'display: none');
            }
            if (resizeObserverErrDiv) {
               resizeObserverErrDiv.setAttribute('style', 'display: none');
            }
         }
      });

      getApplicants();
   }, []);

   const handleSearch = (selectedKeys, confirm, dataIndex) => {
      confirm();
      setSearchText(selectedKeys[0]);
      setSearchedColumn(dataIndex);
   };

   const handleReset = clearFilters => {
      clearFilters();
      setSearchText("");
   };

   const getColumnSearchProps = dataIndex => ({
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
         <div style={{ padding: 8 }}>
            <Input
               ref={node => {
                  //this.searchInput(node);
               }}
               placeholder={`Search ${dataIndex}`}
               value={selectedKeys[0]}
               onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
               onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
               style={{ width: 188, marginBottom: 8, display: 'block' }}
            />
            <Space>
               <Button
                  type="primary"
                  onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                  icon={<SearchOutlined />}
                  size="small"
                  style={{ width: 90 }}>
                  Search
               </Button>
               <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                  Reset
               </Button>
               <Button
                  type="link"
                  size="small"
                  onClick={() => {
                     confirm({ closeDropdown: false });
                     setSearchText(selectedKeys[0]);
                     setSearchedColumn(dataIndex);
                  }}
               >
                  Filter
               </Button>
            </Space>
         </div>
      ),
      filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#033D89' : undefined }} />,
      onFilter: (value, record) =>
         record[dataIndex]
            ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
            : '',
      // onFilterDropdownVisibleChange: visible => {
      //    if (visible) {
      //       setTimeout(() => this.searchInput.select(), 100);
      //    }
      // },
      render: text =>
         searchedColumn === dataIndex ? (
            <Highlighter
               highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
               searchWords={[searchText]}
               autoEscape
               textToHighlight={text ? text.toString() : ''}
            />
         ) : (
            text
         ),
   });

   const columns = [
      {
         title: 'Id',
         key: 'id',
         dataIndex: 'id',
         hidden: true,
      },
      {
         title: 'Last Name',
         key: 'last_name',
         sorter: (a, b) => { return a.last_name.localeCompare(b.last_name) },
         ...getColumnSearchProps('last_name'),
         ellipsis: {
            showTitle: false,
         },
         render: object => (
            <Tooltip placement="topLeft" title={object.last_name}>
               <Text><span style={{ textTransform: 'capitalize' }}>{object.last_name}</span></Text>
            </Tooltip>
         ),
         width: '14%'
      },
      {
         title: 'First Name',
         key: 'first_name',
         sorter: (a, b) => { return a.first_name.localeCompare(b.first_name) },
         ...getColumnSearchProps('first_name'),
         ellipsis: {
            showTitle: true,
         },
         render: object => (
            <Tooltip placement="topLeft" title={object.first_name}>
               <Text><span style={{ textTransform: 'capitalize' }}>{object.first_name}</span></Text>
            </Tooltip>
         ),
         width: '14%'
      },
      {
         title: 'Middle Name',
         key: 'middle_name',
         sorter: (a, b) => { return a.middle_name.localeCompare(b.middle_name) },
         ...getColumnSearchProps('middle_name'),
         ellipsis: {
            showTitle: true,
         },
         render: object => (
            <Tooltip placement="topLeft" title={object.middle_name}>
               <Text><span style={{ textTransform: 'capitalize' }}>{object.middle_name}</span></Text>
            </Tooltip>
         ),
         width: '14%'
      },
      {
         title: 'Gender',
         key: 'gender',
         sorter: (a, b) => { return a.gender.localeCompare(b.gender) },
         ...getColumnSearchProps('gender'),
         ellipsis: {
            showTitle: true,
         },
         render: object => (
            <Text>
               {
                  object.gender !== null
                     ?
                     <span style={{ textTransform: 'capitalize' }}>{object.gender}</span>
                     :
                     <></>
               }
            </Text>
         ),
         width: '8%'
      },
      {
         title: 'Date Applied',
         key: 'date_applied',
         sorter: (a, b) => { return a.date_applied.localeCompare(b.date_applied) },
         ...getColumnSearchProps('date_applied'),
         ellipsis: {
            showTitle: true,
         },
         render: object => (
            <Text>
               {moment(object.date_applied).format('MMM. DD, YYYY hh:mm:ss A')}
            </Text>
         ),
         width: '15%'
      },
      {
         title: 'Application Status',
         key: 'application_status',
         ...getColumnSearchProps('application_status'),
         ellipsis: {
            showTitle: true,
         },
         render: object => (
            <Space size="small">
               {RenderTag(object.application_status)}
            </Space>

         ),
         width: '22%'
      },
      {
         title: 'Action',
         key: 'action',
         render: payload => {
            return (
               <>
                  <Space size="small">
                     {RenderActionButtons(payload)}
                  </Space>
               </>
            );
         },
         width: '20%'
      },
   ].filter(item => !item.hidden);

   const getApplicants = async () => {
      setListLoading(true);
      try {
         // const response = await axios.get(`${process.env.REACT_APP_API_CPH}/getonlineapplicants`);
         const response = await axios.get(`${process.env.REACT_APP_API_CPH}/v2/getonlineapplicants?ur=${user_role}`);
         const data = response.data;

         if (data) {
            // Calculate legend counts using reduce
            const legendCount = data.reduce((counts, applicant) => {
               counts[applicant.application_status] = (counts[applicant.application_status] || 0) + 1;
               return counts;
            }, { pending: 0, accepted: 0, rejected: 0, for_interview: 0, interview_on_hold: 0, enrolled: 0, medical: 0, review_proof_of_payment: 0, on_hold: 0 });

            setLegendCount(legendCount);
            setApplicantList(data);
            setApplicantListFiltered(data);
         }
      } catch (error) {
         console.error('Failed to fetch applicants:', error.message);
      } finally {
         setListLoading(false);
      }
   };

   // const RenderPaidStatus = (data, is_mer_complete) => {
   //    const dpPop = JSON.parse(data);

   //    if (dpPop.status) {
   //       return RenderTag(dpPop.status.toLowerCase());
   //    }

   //    // return is_mer_complete ? RenderTag("medical_complete") : <></>;
   // };

   const RenderTag = (status) => {
      var color = '';

      switch (status) {
         case 'pending':
            color = 'gold';
            break;
         case 'accepted':
            color = 'green'
            break;
         case 'rejected':
            color = 'red';
            break;
         case 'for_interview':
            color = 'blue';
            break;
         case 'for_enrollment':
            color = 'purple';
            break;
         case 'enrolled':
            color = 'cyan';
            break;
         case 'review_medical':
            color = 'gold';
            break;
         case 'medical_complete':
            color = 'green';
            break;
         case 'review_proof_of_payment':
            color = 'gold';
            break;
         case 'on_hold':
            color = 'gold';
            break;
         case 'medical_passed':
            color = 'green';
            break;
         case 'medical_failed':
            color = 'red';
            break;
         case 'interview_passed':
            color = 'green';
            break;
         case 'interview_failed':
            color = 'red';
            break;
         case 'interview_on_hold':
            color = 'gold';
            break;
         case 'rpp_on_hold':
            color = 'gold';
            break;
         default:
      }

      return <>
         <Tag color={color}>
            {
               status.replace(/_/g, ' ').toUpperCase()
            }
         </Tag>
      </>
   }

   const RenderStatusCounts = () => {
      return <>
         <Row style={{ paddingTop: "20px", minWidth: '600px', marginBottom: '20px' }} >
            <Col span={24}>
               <div
                  style={{
                     display: 'flex',
                     flexWrap: 'wrap',
                     gap: '10px',
                     justifyContent: 'center',
                     alignItems: 'center',
                     width: '100%',
                     rowGap: '10px',
                     columnGap: '10px',
                     // marginBottom: 8,
                  }}
               >
                  {
                     ['app-admin', 'registrar', 'clinic', 'cashier'].includes(user_role.toLowerCase()) &&
                     <Badge count={legendCount.pending} style={{ backgroundColor: 'gold' }} overflowCount={999}>
                        <Tag
                           color={"gold"}
                           style={{ cursor: legendCount.pending > 0 ? 'pointer' : 'default', padding: '7px' }}
                           onClick={() => handleFilterListByStatus('pending')}
                        >
                           PENDING
                        </Tag>
                     </Badge>
                  }
                  {
                     ['app-admin', 'interviewer'].includes(user_role.toLowerCase()) &&
                     <Badge count={legendCount.accepted} style={{ backgroundColor: 'green' }} overflowCount={999}>
                        <Tag
                           color={"green"}
                           style={{ cursor: legendCount.accepted > 0 ? 'pointer' : 'default', padding: '7px' }}
                           onClick={() => handleFilterListByStatus('accepted')}
                        >
                           ACCEPTED
                        </Tag>
                     </Badge>
                  }
                  {
                     ['app-admin'].includes(user_role.toLowerCase()) &&
                     <Badge count={legendCount.rejected} style={{ backgroundColor: 'red' }} overflowCount={999}>
                        <Tag
                           color={"red"}
                           style={{ cursor: legendCount.rejected > 0 ? 'pointer' : 'default', padding: '7px' }}
                           onClick={() => handleFilterListByStatus('rejected')}
                        >
                           REJECTED
                        </Tag>
                     </Badge>
                  }
                  {
                     ['app-admin', 'interviewer'].includes(user_role.toLowerCase()) &&
                     <>
                        <Badge count={legendCount.for_interview} style={{ backgroundColor: 'blue' }} overflowCount={999}>
                           <Tag
                              color={"blue"}
                              style={{ cursor: legendCount.for_interview > 0 ? 'pointer' : 'default', padding: '7px' }}
                              onClick={() => handleFilterListByStatus('for_interview')}
                           >
                              FOR INTERVIEW
                           </Tag>
                        </Badge>
                        <Badge count={legendCount.interview_on_hold} style={{ backgroundColor: 'gold' }} overflowCount={999}>
                           <Tag
                              color={"gold"}
                              style={{ cursor: legendCount.interview_on_hold > 0 ? 'pointer' : 'default', padding: '7px' }}
                              onClick={() => handleFilterListByStatus('interview_on_hold')}
                           >
                              INTERVIEW ON-HOLD
                           </Tag>
                        </Badge>
                     </>
                  }
                  {
                     ['app-admin'].includes(user_role.toLowerCase()) &&
                     <>
                        <Badge count={legendCount.interview_passed} style={{ backgroundColor: 'green' }} overflowCount={999}>
                           <Tag
                              color={"green"}
                              style={{ cursor: legendCount.interview_passed > 0 ? 'pointer' : 'default', padding: '7px' }}
                              onClick={() => handleFilterListByStatus('interview_passed')}
                           >
                              INTERVIEW PASSED
                           </Tag>
                        </Badge>
                        <Badge count={legendCount.interview_failed} style={{ backgroundColor: 'red' }} overflowCount={999}>
                           <Tag
                              color={"red"}
                              style={{ cursor: legendCount.interview_failed > 0 ? 'pointer' : 'default', padding: '7px' }}
                              onClick={() => handleFilterListByStatus('interview_failed')}
                           >
                              INTERVIEW FAILED
                           </Tag>
                        </Badge>
                        <Badge count={legendCount.interview_on_hold} style={{ backgroundColor: 'gold' }} overflowCount={999}>
                           <Tag
                              color={"gold"}
                              style={{ cursor: legendCount.interview_on_hold > 0 ? 'pointer' : 'default', padding: '7px' }}
                              onClick={() => handleFilterListByStatus('interview_on_hold')}
                           >
                              INTERVIEW ON-HOLD
                           </Tag>
                        </Badge>
                     </>

                  }
                  {
                     ['app-admin', 'cashier'].includes(user_role.toLowerCase()) &&
                     <>
                        <Badge count={legendCount.review_proof_of_payment} style={{ backgroundColor: 'blue' }} overflowCount={999}>
                           <Tag
                              color={"blue"}
                              style={{ cursor: legendCount.review_proof_of_payment > 0 ? 'pointer' : 'default', padding: '7px' }}
                              onClick={() => handleFilterListByStatus('review_proof_of_payment')}
                           >
                              REVIEW PROOF OF PAYMENT
                           </Tag>
                        </Badge>
                        <Badge count={legendCount.rpp_on_hold} style={{ backgroundColor: 'gold' }} overflowCount={999}>
                           <Tag
                              color={"gold"}
                              style={{ cursor: legendCount.rpp_on_hold > 0 ? 'pointer' : 'default', padding: '7px' }}
                              onClick={() => handleFilterListByStatus('rpp_on_hold')}
                           >
                              RPP ON-HOLD
                           </Tag>
                        </Badge>
                     </>
                  }

                  {
                     ['app-admin', 'registrar'].includes(user_role.toLowerCase()) &&
                     <>
                        <Badge count={legendCount.for_enrollment} style={{ backgroundColor: 'purple' }} overflowCount={999}>
                           <Tag
                              color={"purple"}
                              style={{ cursor: legendCount.for_enrollment > 0 ? 'pointer' : 'default', padding: '7px' }}
                              onClick={() => handleFilterListByStatus('for_enrollment')}
                           >
                              FOR ENROLLMENT
                           </Tag>
                        </Badge>
                     </>
                  }
                  <Badge count={legendCount.enrolled} style={{ backgroundColor: 'cyan' }} overflowCount={999}>
                     <Tag
                        color={"cyan"}
                        style={{ cursor: legendCount.enrolled > 0 ? 'pointer' : 'default', padding: '7px' }}
                        onClick={() => handleFilterListByStatus('enrolled')}
                     >
                        ENROLLED
                     </Tag>
                  </Badge>
                  <Button className='button-shadow' type='primary' shape='round' onClick={() => getApplicants()}>Refresh</Button>
               </div>
            </Col>
         </Row>
      </>
   }

   const handleFilterListByStatus = (status) => {
      var filteredList = applicantList.filter(student => student.application_status === status);

      setApplicantListFiltered(filteredList);
   }

   const handleReviewApplication = (id, status) => {
      navigate(`/reviewapplication?id=${id}`, { state: { status } });
   }

   const handleViewIPPOP = (id, status) => {
      //-- Get proof of payment url from documents
      var items = applicantListFiltered.filter(item => item.id === id);
      let dpPopData = JSON.parse(items[0].dp_pop);

      setDpData(dpPopData);

      setDocToView(dpPopData.document);
      setApplicationStatus(status);
      setApplicantID(id);
      setModalPoPValidate(true);
   }

   const handleMarkIPAsPaid = async (status) => {
      setUpdating(true);

      try {
         // Find the applicant by ID (assumes applicantListFiltered is available in scope)
         const applicant = applicantListFiltered.find((item) => item.id === applicantID);
         if (!applicant) {
            throw new Error("Applicant not found");
         }

         // Parse dp_pop and create an immutable updated version
         const dpPopData = JSON.parse(applicant.dp_pop || "{}");
         const updatedDpPopData = { ...dpPopData, status, receipt_no: status === "paid" ? receiptNo ? receiptNo.trim() : "" : "" };

         // API call to mark as paid
         const url = `${process.env.REACT_APP_API_CPH}/v2/markaspaid?id=${applicantID}&m="save"`;
         const response = await axios.post(url, updatedDpPopData);

         if (!response.data) {
            throw new Error("No data returned from server");
         }

         // Update UI on success
         setModalPoPValidate(false);
         Modal.success({
            title: "Online Application",
            content: "Operation successful.",
            centered: true,
            onOk: getApplicants, // Assuming getApplicants is in scope
         });
      } catch (error) {
         console.error("Failed to mark as paid:", error.message);
         Modal.error({
            title: "Online Application",
            content: error.message || "Operation failed. Please try again.",
            centered: true,
         });
      } finally {
         setUpdating(false);
      }
   };

   // function MERUploadComplete(mer_data) {
   //    var merData = JSON.parse(mer_data);
   //    const hasMissingRequiredDocs = merData.some((item) => item.required && !item.document);

   //    return !hasMissingRequiredDocs;
   // }

   // const handleReviewMER = (id) => {
   //    navigate(`/review-docs?id=${id}`);
   // }

   const handleInterview = (id, mode = 'edit') => {
      navigate(`/interview?id=${id}`, { state: { mode } });
   }

   const RenderActionButtons = (payload) => {
      var dpPop = payload.dp_pop !== null && payload.dp_pop !== '' ? JSON.parse(payload.dp_pop) : { document: "", receipt_no: "", status: "" };

      return (
         <>
            {/* <Space size="small"> */}
            <div style={{ width: "100%", justifyContent: "left", display: "flex", flexWrap: "wrap", gap: "5px" }}>
               {
                  (['Cashier'].includes(user_role) && payload.application_status === 'pending' && !payload.is_pop_valid) &&
                  <Button type='primary' size='small' shape='round' onClick={() => handleViewAFPOP(payload.id, payload.applicationStatus)}><EyeOutlined /></Button>
               }
               {
                  (['Clinic'].includes(user_role) && payload.application_status === 'pending' && !payload.mer_complete) &&
                  <Button type='primary' size='small' shape='round' onClick={() => handleViewMedCert(payload.id, payload.applicationStatus)}><EyeOutlined /></Button>
               }
               {
                  ['App-Admin'].includes(user_role) &&
                  <Button type='primary' size='small' shape='round' onClick={() => handleReviewApplication(payload.id, payload.application_status)}>View</Button>
               }
               {
                  (['Registrar'].includes(user_role) && payload.application_status === 'pending' && payload.is_pop_valid && payload.mer_complete) &&
                  <Button type='primary' size='small' shape='round' onClick={() => handleReviewApplication(payload.id, payload.application_status)}>Review</Button>
                  // <Button type='primary' size='small' shape='round' onClick={() => handleReviewApplication(payload.id, payload.application_status)}>{payload.application_status === 'pending' && !["Interviewer", "Clinic"].includes(user_role) ? 'Review' : 'View'}</Button>
               }
               {
                  (['Interviewer'].includes(user_role) && (['accepted'].includes(payload.application_status))) &&
                  <Button type="primary" size="small" shape="round" onClick={() => showModalSchedule(payload.id, true)}>Set Interview</Button>
               }
               {
                  (['App-Admin', 'Interviewer'].includes(user_role) && payload.application_status === 'interview_passed') &&
                  <Button type="primary" size="small" shape="round" onClick={() => handleInterview(payload.id, 'view')}>Interview Result</Button>
               }
               {(['Interviewer'].includes(user_role) && (['interview_on_hold', 'for_interview'].includes(payload.application_status))) && (
                  payload.interview_ready ? (
                     <>
                        <Button type="primary" size="small" shape="round" onClick={() => handleInterview(payload.id)}>Interview</Button>
                        <Button type="primary" size="small" shape="round" onClick={() => showModalSchedule(payload.id, true)}>Re-schedule Interview</Button>
                        <Popconfirm
                           title="Are you sure you want to reject this application?"
                           onConfirm={() => handleRejectApplicant(payload.id)}
                           okText="Yes"
                           cancelText="No"
                        >
                           <Button type='primary' size="small" shape='round'>Reject</Button>
                        </Popconfirm>
                     </>
                  ) : (
                     <Button type="primary" size="small" shape="round">Schedule: {payload.interview_schedule}</Button>
                  )
               )}
               {
                  // (user_role === 'Cashier' && dpPop.document !== "" && (payload.application_status === 'medical_passed' || payload.application_status === 'medical_passed_with_condition')) &&
                  (user_role === 'Cashier' && ['review_proof_of_payment', 'rpp_on_hold'].includes(payload.application_status)) &&
                  <Button type='primary' size='small' shape='round' onClick={() => handleViewIPPOP(payload.id, payload.applicationStatus)}><EyeOutlined /></Button>
               }
               {/* {
                  // (user_role === 'Clinic' && payload.application_status === 'review_medical' && !payload.mer_complete) &&
                  (user_role === 'Clinic' && payload.application_status === 'review_medical') &&
                  <Button type='primary' size='small' shape='round' onClick={() => handleReviewMER(payload.id)}>{'Medical Exam Results'}</Button>
               } */}
               {
                  (user_role === 'Registrar' && ['for_enrollment'].includes(payload.application_status) && dpPop.status === "paid") &&
                  <>
                     <Button type='primary' size='small' shape='round' onClick={() => handleMarkEnrolled(payload.id)}>Mark as Enrolled</Button>
                     <Button type="primary" size="small" shape="round" onClick={() => handleInterview(payload.id, 'view')}>Interview Result</Button>
                  </>
               }
            </div>
            {/* </Space> */}
         </>
      );
   }

   const handleMarkEnrolled = (id) => {
      Modal.confirm({
         title: 'Online Application',
         content: 'Are you sure you want to mark this student as enrolled?',
         centered: true,
         onOk() {
            setUpdating(true);
            axios.post(`${process.env.REACT_APP_API_CPH}/tagasenrolled?id=${id}`).then((response) => {
               if (response.data) {
                  setUpdating(false);

                  Modal.success({
                     title: 'Online Application',
                     content: 'Operation successful.',
                     centered: true,
                     onOk: getApplicants,
                  });
               }
            }, (error) => {
               setUpdating(false);
               Modal.error({
                  title: 'Online Application',
                  content: 'Operation failed.',
                  centered: true
               });
            });
         },
         onCancel() {
            console.log('Cancel');
         },
      });
   }

   const handleSaveReceipt = async () => {
      setUpdating(true);

      try {
         // Find the applicant by ID (assumes applicantListFiltered is available in scope)
         const applicant = applicantListFiltered.find((item) => item.id === applicantID);
         if (!applicant) {
            throw new Error("Applicant not found");
         }

         // Parse dp_pop and create an immutable updated version
         const dpPopData = JSON.parse(applicant.dp_pop || "{}");
         const updatedDpPopData = {
            ...dpPopData,
            receipt_no: receiptNo,
         };

         // // Validate receipt number if status is "Paid"
         // if (status === "Paid" && !updatedDpPopData.receipt_no) {
         //    throw new Error("Receipt number is required for Paid status");
         // }

         // API call to mark as paid
         const url = `${process.env.REACT_APP_API_CPH}/v2/markaspaid?id=${applicantID}&m="update"`;
         const response = await axios.post(url, updatedDpPopData);

         if (!response.data) {
            throw new Error("No data returned from server");
         }

         // Update UI on success
         setModalPoPValidate(false);
         Modal.success({
            title: "Online Application",
            content: "Operation successful.",
            centered: true,
            onOk: getApplicants, // Assuming getApplicants is in scope
         });
      } catch (error) {
         console.error("Failed to mark as paid:", error.message);
         Modal.error({
            title: "Online Application",
            content: error.message || "Operation failed. Please try again.",
            centered: true,
         });
      } finally {
         setUpdating(false);
      }
   }

   const handleSetInterviewSchedule = () => {
      setModalSchedule(false);
      setUpdating(true);
      var url = `${process.env.REACT_APP_API_CPH}/setinterviewschedule?id=${applicantID}&sched=${moment(schedule).format("YYYY-MM-DD HH:mm:ss")}`;

      axios.post(url).then((response) => {
         if (response.data) {
            setModalSchedule(false);
            setUpdating(false);
            Modal.success({
               title: 'Online Application',
               content: 'Setting interview schedule successful.',
               centered: true,
               onOk: getApplicants,
            });
         }
      }, (error) => {
         setModalSchedule(false);
         setUpdating(false);
         Modal.error({
            title: 'Online Application',
            content: 'Setting interview schedule failed.',
            centered: true
         });
         console.log(error.message);
      });
   }

   const showModalSchedule = (applicant_id, show) => {
      setApplicantID(applicant_id);
      setModalSchedule(show);
   }

   const handleViewAFPOP = (id, status) => {
      //-- Get proof of payment url from documents
      var items = applicantListFiltered.filter(item => item.id === id);
      let documents = JSON.parse(items[0].documents);

      setDocToView(documents.af_proof_of_payment);
      setApplicationStatus(status);
      setApplicantID(id);
      setModalAFPoP(true);
   }

   const handleMarkAFAsPaid = async (value) => {
      setUpdating(true);
      try {
         // Find the applicant by ID (assumes applicantListFiltered is available in scope)
         const applicant = applicantListFiltered.find((item) => item.id === applicantID);
         if (!applicant) {
            throw new Error("Applicant not found");
         }

         // API call to mark as paid
         const url = `${process.env.REACT_APP_API_CPH}/v3/markaspaid?id=${applicantID}&v=${value}`;
         const response = await axios.post(url);

         if (!response.data) {
            throw new Error("No data returned from server");
         }
         // Update UI on success
         setModalAFPoP(false);
         Modal.success({
            title: "Online Application",
            content: "Operation successful.",
            centered: true,
            onOk: getApplicants, // Assuming getApplicants is in scope
         });
      } catch (error) {
         console.error("Failed to mark as paid:", error.message);
         Modal.error({
            title: "Online Application",
            content: error.message || "Operation failed. Please try again.",
            centered: true,
         });
      } finally {
         setUpdating(false);
      }
   };

   const handleViewMedCert = (id) => {
      //-- Get proof of payment url from documents
      var items = applicantListFiltered.filter(item => item.id === id);
      let documents = JSON.parse(items[0].documents);
      setDocToView(documents.medical_certificate);
      setApplicantID(id);
      setModalMedCert(true);
   }

   const handleMarkMedCertAsValid = async (is_valid) => {
      setUpdating(true);
      try {
         // Find the applicant by ID (assumes applicantListFiltered is available in scope)
         const applicant = applicantListFiltered.find((item) => item.id === applicantID);
         if (!applicant) {
            throw new Error("Applicant not found");
         }
         // API call to mark as paid
         const url = `${process.env.REACT_APP_API_CPH}/markmedcertasvalid?id=${applicantID}&v=${is_valid}`;
         const response = await axios.post(url);
         if (!response.data) {
            throw new Error("No data returned from server");
         }
         // Update UI on success
         setModalMedCert(false);
         Modal.success({
            title: "Online Application",
            content: "Operation successful.",
            centered: true,
            onOk: getApplicants, // Assuming getApplicants is in scope
         });
      } catch (error) {
         console.error("Failed to mark as valid:", error.message);
         Modal.error({
            title: "Online Application",
            content: error.message || "Operation failed. Please try again.",
            centered: true,
         });
      } finally {
         setUpdating(false);
      }
   };

   const handleRejectApplicant = (id) => {
      setUpdating(true);

      var url = `${process.env.REACT_APP_API_CPH}/rejectapplicant?id=${id}`;

      axios.post(url).then((response) => {
         if (response.data) {

            Modal.success({
               title: 'Online Application',
               content: 'Application was successfuly rejected.',
               centered: true,
               onOk: navigate('/applicantlist')
            });

            setUpdating(false);
         }
      }, (error) => {
         Modal.error({
            title: 'Online Application',
            content: 'Operation failed.',
            centered: true
         });
         setUpdating(false);
      });
   }

   return (
      <>
         <ProcessingModal
            processing={updating}
            title={'Brainee LMS'}
         />
         <div className="dashboard-area-all">
            <div className="dashboard-item">
               <div className="dashboard-item-inner">
                  <ul>
                     <li className="active">Tracker for Student Applicants</li>
                  </ul>
               </div>

               <div className="dashboard-item-inner3">
                  {RenderStatusCounts()}
                  <Table
                     loading={listLoading}
                     size='small'
                     rowKey={'uid'}
                     columns={columns}
                     dataSource={applicantListFiltered}
                     pagination={false}
                     scroll={{
                        x: '1000px',
                        y: 'calc(100vh - 17.5rem)',
                     }}
                     footer={() => 'Total Records: ' + applicantListFiltered.length}
                  />
               </div>
            </div>
         </div>

         <Modal
            key="modal-schedule"
            title='Online Application'
            destroyOnClose={true}
            centered
            okText={"Set"}
            cancelText={"Close"}
            open={modalSchedule}
            okButtonProps={{ shape: "round" }}
            cancelButtonProps={{ shape: "round" }}
            onOk={() => handleSetInterviewSchedule()}
            onCancel={() => setModalSchedule(false)}
         >
            <Text style={{ verticalAlign: "middle" }}>Set Interview Schedule</Text>
            <DatePicker
               placeholder="Select Date"
               showTime={{ format: 'hh:mm A', use12Hours: true }}
               format={customFormat}
               style={{ width: "100%" }}
               disabledDate={(current) => current.isBefore(moment().subtract(1, "day"))}
               onBlur={(event) => setSchedule(event.target.value)}
            />
         </Modal>

         <Modal
            key='pop-validate'
            title={"Proof of Payment for Initial Payment"}
            okText={"Paid"}
            cancelText={'Not Paid'}
            okButtonProps={{ type: 'primary', shape: "round" }}
            cancelButtonProps={{ type: 'primary', shape: 'round' }}
            centered
            destroyOnClose={true}
            open={modalPoPValidate}
            width='75%'

            footer={[
               <Row>
                  <Col span={12} style={{ textAlign: 'left' }}>
                     <Typography.Text>Receipt No. </Typography.Text>
                     <Input
                        size='middle'
                        // disabled={dpData.receipt_no !== "" ? true : false}
                        placeholder='Enter Receipt No.'
                        style={{ width: "200px", borderRadius: "7px" }}
                        onChange={e => setReceiptNo(e.target.value)}
                        defaultValue={dpData.receipt_no}
                     />
                     {
                        (user_role === 'Cashier' && (dpData.receipt_no !== "" && dpData.receipt_no !== null)) &&
                        <>
                           &nbsp;
                           <Button key="save" type='primary' shape='round' onClick={() => handleSaveReceipt()}>Update</Button>
                        </>
                     }
                  </Col>
                  <Col span={12} style={{ textAlign: 'right' }}>
                     <Button key="paid" type='primary' shape='round' onClick={() => handleMarkIPAsPaid('paid')} disabled={(dpData.receipt_no !== "" && dpData.receipt_no !== null) || applicationStatus === "enrolled" ? true : false}>Paid</Button>
                     <Button key="onhold" type='primary' shape='round' onClick={() => handleMarkIPAsPaid('rpp_on_hold')} disabled={(dpData.receipt_no !== "" && dpData.receipt_no !== null) || applicationStatus === "enrolled" ? true : false}>On-hold</Button>
                     <Button key="close" type="primary" shape='round' onClick={() => setModalPoPValidate(false)}>Close</Button>
                  </Col>
               </Row>,
            ]}
         >
            <div className='student_list_container'>
               <DocumentViewer
                  document={docToView}
                  pdfshowdownload={true}
                  pdfshowprint={true}
                  ismodal={true}
                  dvheight={"calc(100vh - 220px)"}
               />
            </div>
         </Modal>

         <Modal
            key='af-pop-validate'
            title={"Proof of Payment for Application Fee"}
            okText={"Paid"}
            cancelText={'Not Paid'}
            okButtonProps={{ type: 'primary', shape: "round" }}
            cancelButtonProps={{ type: 'primary', shape: 'round' }}
            centered
            destroyOnClose={true}
            open={modalAFPoP}
            width='75%'

            footer={[
               <Row>
                  <Col span={12} style={{ textAlign: 'left' }}>
                  </Col>
                  <Col span={12} style={{ textAlign: 'right' }}>
                     <Button key="paid" type='primary' shape='round' onClick={() => handleMarkAFAsPaid(true)} >Paid</Button>
                     <Button key="notpaid" type='primary' shape='round' onClick={() => handleMarkAFAsPaid(false)}>Not Paid</Button>
                     <Button key="close" type="primary" shape='round' onClick={() => setModalAFPoP(false)}>Close</Button>
                  </Col>
               </Row>,
            ]}
         >
            <div className='student_list_container'>
               <DocumentViewer
                  document={docToView}
                  pdfshowdownload={true}
                  pdfshowprint={true}
                  ismodal={true}
                  dvheight={"calc(100vh - 220px)"}
                  padurl={false}
               />
            </div>
         </Modal>

         <Modal
            key='med-cert-view'
            title={"Medical Certificate"}
            okText={"Valid"}
            cancelText={'Not Valid'}
            okButtonProps={{ type: 'primary', shape: "round" }}
            cancelButtonProps={{ type: 'primary', shape: 'round' }}
            centered
            destroyOnClose={true}
            open={modalMedCert}
            width='75%'

            footer={[
               <Row>
                  <Col span={12} style={{ textAlign: 'left' }}>
                  </Col>
                  <Col span={12} style={{ textAlign: 'right' }}>
                     <Button key="valid" type='primary' shape='round' onClick={() => handleMarkMedCertAsValid(true)} >Valid</Button>
                     <Button key="notvalid" type='primary' shape='round' onClick={() => handleMarkMedCertAsValid(false)}>Not Valid</Button>
                     <Button key="close" type="primary" shape='round' onClick={() => setModalMedCert(false)}>Close</Button>
                  </Col>
               </Row>,
            ]}
         >
            <div className='student_list_container'>
               <DocumentViewer
                  document={docToView}
                  pdfshowdownload={true}
                  pdfshowprint={true}
                  ismodal={true}
                  dvheight={"calc(100vh - 220px)"}
                  padurl={false}
               />
            </div>
         </Modal>
      </>
   );
}
